import { getDocument } from '@atlaskit/browser-apis';
import { THEME_DATA_ATTRIBUTE } from '@atlaskit/tokens/constants';
import type { ThemeIds } from '@atlaskit/tokens/theme-config';

/**
 * Checks if a theme is mounted in the document head.
 *
 * Eventually this won't be necessary as we'll utilise AppProvider context
 * to track theme loading.
 */
export function isThemeMounted(themeId: ThemeIds): false | Element | null {
	const doc = getDocument();
	if (!doc) {
		return false;
	}
	return doc.head.querySelector(`style[${THEME_DATA_ATTRIBUTE}="${themeId}"]`);
}
